import {focusNewAttributeEvent} from '../../../../../../services/query_builder_events';
import DatasetAttributeGroup from '../dataset_attribute_group';
import ColumnAttribute from './column_attribute';
import {ATTRIBUTES} from "../../../../../../utils/query_utils";

export default class ColumnsGroup extends DatasetAttributeGroup {
    placeholder = 'Campaign';
    type = ATTRIBUTES.COLUMN;
    AttributeComponent = ColumnAttribute;

    componentDidMount() {
        super.componentDidMount();

        this.unbindNextAttributeListener = focusNewAttributeEvent.listen(() => {
            setTimeout(this.focusDummyAttribute.bind(this), 100);
        });
    }

    componentWillUnmount() {
        super.componentWillUnmount();

        this.unbindNextAttributeListener();
    }
}
